export var VALIDATE_CODES;
(function (VALIDATE_CODES) {
    VALIDATE_CODES["default"] = "default";
    VALIDATE_CODES["required"] = "required";
    VALIDATE_CODES["maxLength"] = "maxLength";
    VALIDATE_CODES["minLength"] = "minLength";
    VALIDATE_CODES["maxNumber"] = "maxNumber";
    VALIDATE_CODES["minNumber"] = "minNumber";
})(VALIDATE_CODES || (VALIDATE_CODES = {}));
//# sourceMappingURL=codes.js.map